import { Button, TextField } from "@mui/material";
import clsx from "clsx";
import { Formik } from "formik";
import React from "react";
import { t } from "ttag";
import * as Yup from "yup";
import SimpleModal from "../../widgets/SimpleModal/SimpleModal";
import useStyles from "./AddEditDebugDevice.style";

const DeviceSchema = Yup.object().shape({
  serial: Yup.string().required(t`Required`),
  comment: Yup.string().required(t`Required`),
});

const AddEditDebugDevice = ({ isEdit, device, setOpenAddEdit, handleSave }: any) => {
  const styles: any = useStyles();

  const CustomizedTextField = ({
    label,
    handleChange,
    errors,
    name,
    helperText,
    values,
    disabled
  }: any) => (
    <TextField
      label={label}
      name={name}
      helperText={errors[name] || helperText}
      className={styles.fieldStyle}
      variant={'standard'}
      onChange={handleChange}
      value={values[name] || ""}
      error={!!errors[name]}
      disabled={disabled}
    />
  );

  return (
    <SimpleModal showModal={true} title={isEdit ? t`Edit Debug Device` : t`Create Debug Device`} hideBtns>
      <Formik
        initialValues={{
          serial: isEdit && device ? device.serial : "",
          comment: isEdit && device ? device.comment : "",
        }}
        enableReinitialize={true}
        validateOnChange={false}
        onSubmit={(values) => {
          handleSave(values);
        }}
        validationSchema={DeviceSchema}
      >
        {(props: any) => {
          const { values, errors, handleChange, handleSubmit } = props;
          return (
            <form className={styles.fieldsContainer} onSubmit={handleSubmit}>
              <CustomizedTextField
                label={t`Serial`}
                name="serial"
                helperText={t`Device Serial`}
                disabled={isEdit}
                handleChange={handleChange}
                values={values}
                errors={errors}
              />
              <CustomizedTextField
                label={t`Comment`}
                name="comment"
                helperText={t`Device Comment`}
                handleChange={handleChange}
                values={values}
                errors={errors}
              />
              
              <div className={styles.actionsContainer}>
                <Button onClick={() => setOpenAddEdit(null)} className={styles.sharedButtonStyle}>
                  {t`Cancel`}
                </Button>
                <Button
                  type="submit"
                  className={clsx(styles.sharedButtonStyle, styles.submitButton)}
                >
                  {isEdit ? t`Update` : t`Create`}
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
    </SimpleModal>
  );
};

export default AddEditDebugDevice;
